// WARNING: this file is AUTOGENERATED, only main.ts and index.ts are editable
// rerun yarn generate:enums to update

import { getAttendanceStatusById } from 'app/constants/enums/AttendanceStatus/main';

/* eslint-disable max-len */
export const ABSENT = getAttendanceStatusById('absent');
export const COMPLETE = getAttendanceStatusById('complete');
export const PARTIAL = getAttendanceStatusById('partial');
/* eslint-enable max-len */
